const $ = require("../../node_modules/jquery/dist/jquery.min");

module.exports = {
  init: () => {
    const elementInViewport = el => {
      let top = el.offsetTop;
      let height = el.offsetHeight;

      return height + top !== 0;
    };

    $(() => {
      function isHeaderSticky() {
        return $(".mediaquery--tablet").is(":visible");
      }

      var element = $(".header");
      var menuItem = $(".header-menu-item");

      let elTotalHeight = 0,
        elHeight = 0,
        elTop = 0,
        $window = $(window),
        wScrollCurrent = 0,
        wScrollBefore = 0,
        wScrollDiff = 0,
        scrollTo = 0;

      function headerUpdate() {
        elHeight = element.outerHeight();
        elTotalHeight = elHeight;
        wScrollCurrent = $window.scrollTop();
        wScrollDiff = wScrollBefore - wScrollCurrent;
        elTop = parseInt(element.css("top")) + wScrollDiff;

        if (isHeaderSticky() === false) {
          if (wScrollCurrent <= 0) {
            // scrolled to the very top; element sticks to the top
            element.css("top", 0);
          } else {
            scrollTo = 0;
            if (wScrollDiff > 0) {
              // scrolled up; element slides in
              if (element.hasClass("header--hidden")) {
                element.css("top", "-124px");

                wScrollBefore = -124;
              } else {
                element.css("top", elTop > scrollTo ? scrollTo : elTop);
              }
            } else if (wScrollDiff < 0) {
              // scrolled down
              element.css("top", Math.abs(elTop) > elTotalHeight ? -elTotalHeight : elTop);
              if (wScrollCurrent > elTotalHeight) {
                menuItem.removeClass("header-menu-item--open");
              }
            }
          }
          wScrollBefore = wScrollCurrent;
        }
      }

      headerUpdate();

      $window.on("scroll", headerUpdate);

      $(window).resize(function() {
        headerUpdate();
      });
    });
  }
};
